import { isNullOrUndefined } from 'src/app/helpers/tools';
import {JWTHelper} from "./jwt.helper";
import {AccountIDs} from "../shared/models/AccountIDs";
import {Permissions} from "../shared/models/Permissions";

export class PermissionHelper {
    public static hasPermission(permission: string): boolean {
        var userToken = JWTHelper.decodeJwt(localStorage.getItem('jwt'));

        if (isNullOrUndefined(userToken) || (isNullOrUndefined(userToken.permission) && isNullOrUndefined(userToken.AllPermissions))) {
            return false;
        }
        
        if (userToken.AllPermissions == "1") {
            return true;
        } else {
            if (typeof userToken.permission === "string") {
                return userToken.permission === permission;
            } else {
                return userToken.permission.findIndex(r => r === permission) !== -1;
            }
        }
    }

    public static hasAllPermissions(): boolean {
        var userToken = JWTHelper.decodeJwt(localStorage.getItem('jwt'));

        if (isNullOrUndefined(userToken) || isNullOrUndefined(userToken.AllPermissions)) {
            return false;
        }

        return userToken.AllPermissions == "1";
    }

    public static isSuperiorUser(): boolean {
        var userToken = JWTHelper.decodeJwt(localStorage.getItem('jwt'));

        if (isNullOrUndefined(userToken)) {
            return false;
        }
        
        return userToken.AllPermissions == "1" || userToken.IsGlobalSupport == "1" || (userToken.permission && userToken.permission.includes(Permissions.Supporter));
    }

    public static inRole(roleNames: string[]): boolean {
        var userToken = JWTHelper.decodeJwt(localStorage.getItem('jwt'));

        if (isNullOrUndefined(userToken) || isNullOrUndefined(userToken.role)) {
            return false;
        }

        if (isNullOrUndefined(roleNames) || roleNames.length === 0) {
            return true;
        }

        if (typeof userToken.role === "string") {
            return roleNames.findIndex(ro => ro === userToken.role) !== -1;
        } else {
            return userToken.role.findIndex(r => roleNames.findIndex(ro => ro === r) !== -1) !== -1;
        }
    }

    public static isDistributorUser(): boolean {
        var userToken = JWTHelper.decodeJwt(localStorage.getItem('jwt'));

        if (isNullOrUndefined(userToken) || isNullOrUndefined(userToken.Rata_DistributorId)) {
            return false;
        }

        return Boolean(userToken.Rata_DistributorId);
    }

    public static distributorID(): number | null {
        var userToken = JWTHelper.decodeJwt(localStorage.getItem('jwt'));

        if (isNullOrUndefined(userToken) || !userToken.Rata_DistributorId || !parseInt(userToken.Rata_DistributorId)) {
            return null;
        }

        return parseInt(userToken.Rata_DistributorId);
    }

    public static isGroupUser(): boolean {
        var userToken = JWTHelper.decodeJwt(localStorage.getItem('jwt'));

        if (isNullOrUndefined(userToken) || isNullOrUndefined(userToken.Rata_LaboratoryGroupId)) {
            return false;
        }

        return Boolean(userToken.Rata_LaboratoryGroupId);
    }

    public static groupID(): number | null {
        var userToken = JWTHelper.decodeJwt(localStorage.getItem('jwt'));

        if (isNullOrUndefined(userToken) || !userToken.Rata_LaboratoryGroupId || !parseInt(userToken.Rata_LaboratoryGroupId)) {
            return null;
        }

        return parseInt(userToken.Rata_LaboratoryGroupId);
    }

    public static isSiteUser(): boolean {
        var userToken = JWTHelper.decodeJwt(localStorage.getItem('jwt'));

        if (isNullOrUndefined(userToken) || isNullOrUndefined(userToken.Rata_LaboratoryId)) {
            return false;
        }

        return Boolean(userToken.Rata_LaboratoryId);
    }

    public static siteID(): number | null {
        var userToken = JWTHelper.decodeJwt(localStorage.getItem('jwt'));

        if (isNullOrUndefined(userToken) || isNullOrUndefined(userToken.Rata_LaboratoryId)) {
            return null;
        }

        return parseInt(userToken.Rata_LaboratoryId);
    }

    public static isAccountUser(): boolean {
        var userToken = JWTHelper.decodeJwt(localStorage.getItem('jwt'));

        if (isNullOrUndefined(userToken) || isNullOrUndefined(userToken.Rata_AccountId)) {
            return false;
        }

        return Boolean(userToken.Rata_AccountId);
    }

    public static accountID(): number | null {
        var userToken = JWTHelper.decodeJwt(localStorage.getItem('jwt'));

        if (isNullOrUndefined(userToken) || isNullOrUndefined(userToken.Rata_AccountId)) {
            return null;
        }

        return parseInt(userToken.Rata_AccountId);
    }

    public static isSuperUser(): boolean {
        return this.hasAllPermissions();
    }

    /**
     * User has no roles
     * @returns
     */
    public static isNewUser(): boolean {
        return this.inRole(['NewUser']);
    }

    /**
     * Identify if the current account or laboratory has subscriptions
     * @returns
     */
    public static hasSubs(): boolean {
        return this.inRole(['HasSubs']);
    }

    public static isProcessingSite(): boolean {
        var userToken = JWTHelper.decodeJwt(localStorage.getItem('jwt'));

        if (isNullOrUndefined(userToken) || (isNullOrUndefined(userToken.RataTracProcessingSite))) {
            return false;
        }

        return userToken.RataTracProcessingSite == "1";
    }

    public static isGlobalSupport(): boolean {
        var userToken = JWTHelper.decodeJwt(localStorage.getItem('jwt'));

        if (isNullOrUndefined(userToken) || (isNullOrUndefined(userToken.permission) && isNullOrUndefined(userToken.IsGlobalSupport))) {
            return false;
        }

        return userToken.IsGlobalSupport == "1";
    }
    
    public static get accountIDs() {
        return new AccountIDs(this.accountID(), this.siteID(), this.groupID(), this.distributorID());
    }

    public static isStaffUser(): boolean {
        var userToken = JWTHelper.decodeJwt(localStorage.getItem('jwt'));

        if (isNullOrUndefined(userToken) || isNullOrUndefined(userToken.Rata_StaffId)) {
            return false;
        }

        return Boolean(userToken.Rata_StaffId);
    }

    public static isOldStaffUser(): boolean {
        var userToken = JWTHelper.decodeJwt(localStorage.getItem('jwt'));

        if (isNullOrUndefined(userToken) || isNullOrUndefined(userToken.Renee_StaffId)) {
            return false;
        }

        return Boolean(userToken.Renee_StaffId);
    }

    public static isOldMarkupStaff(): boolean {
        var userToken = JWTHelper.decodeJwt(localStorage.getItem('jwt'));

        if (isNullOrUndefined(userToken) || isNullOrUndefined(userToken.Renee_StaffId) || isNullOrUndefined(userToken.Renee_MarkupStaff)) {
            return false;
        }

        return Boolean(userToken.Renee_MarkupStaff);
    }
}